import { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import message from 'antd/lib/message'

import { commonHelper } from 'helpers'
import AuthContext from 'contexts/AuthContext'
import { useCustomMutation } from 'services/shared/mutation'
import { SignUpPayload } from 'services/shared/mutation.payload'
import { signUpMutation } from 'gql/user'
import { eventManager } from 'utils'

const useSignUp = () => {
  const { refetch } = useContext(AuthContext)
  const signUp = useCustomMutation<SignUpPayload>({ mutation: signUpMutation })
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [hasIressDetails, setHasIressDetails] = useState(false)
  const [isDirectlyAuthorised, setIsDirectlyAuthorised] = useState(true)

  const handleSwitchChange = (e: any) => {
    setHasIressDetails(e.target.checked)
  }

  const handleDirectlyAuthorisedChange = (e: any) => {
    setIsDirectlyAuthorised(e.target.checked)
  }

  const handleSubmit = async ({
    email,
    password,
    firstName,
    lastName,
    phoneNumber,
    accountType,
    mobileNumber,
    networkDetails,
    // iress fields
    iressLoginId,
    iressPassword,
    iressUserId,
    fcaNumber,
  }: {
    email: string
    password: string
    firstName: string
    lastName: string
    phoneNumber: string
    accountType: string
    mobileNumber?: string
    networkDetails?: string
    // iress fields
    iressLoginId?: string
    iressPassword?: string
    iressUserId?: number
    fcaNumber?: string
  }): Promise<void> => {
    try {
      setLoading(true)

      if (String(fcaNumber) && String(fcaNumber).length !== 6 && String(fcaNumber).length !== 7) {
        message.info('Please check FCA number, it should be 6 or 7 digits')
        setLoading(false)
        return
      }

      const { errors, data } = await signUp({
        email,
        password,
        firstName,
        lastName,
        phoneNumber,
        accountType,
        isDirectlyAuthorised,
        mobileNumber,
        networkDetails,
        // iress fields
        iressLoginId,
        iressPassword,
        iressUserId: iressUserId ? Number(iressUserId) : undefined,
        fcaNumber: fcaNumber ? Number(fcaNumber) : undefined,
        isPERCUser: true,
      })
      if (errors?.length) {
        setLoading(false)
        const errMessage = commonHelper.parseGraphqlErrorMessage(errors)
        message.error(errMessage)
        return
      }

      const accessToken = data.signUp.accessToken
      localStorage.setItem('accessToken', accessToken)

      await refetch()
      setLoading(false)

      navigate('/clients')

      if (iressLoginId || iressPassword || iressUserId) {
        eventManager.openIressDetailsModal(
          {},
          {
            confirm: refetch,
          },
        )
      }
    } catch (err) {
      // pass.
    }
  }

  return {
    handleSubmit,
    loading,
    hasIressDetails,
    handleSwitchChange,
    isDirectlyAuthorised,
    handleDirectlyAuthorisedChange,
  }
}

export default useSignUp
